const waiting = "text-center text-muted-foreground py-8 font-mono text-sm";

const container = "font-mono";

// ProviderNode
const providerNode = "flex items-center gap-1 md:gap-1.5 py-0.5 px-1 md:py-0.5 md:px-1.5 rounded-md hover:bg-accent transition-colors duration-100";

const providerNodeEntriesWrapper = "flex-1 flex items-center gap-1 md:gap-1.5 min-w-0";

const providerNodeEntryMessage = "font-mono text-[9px] md:text-[11px] text-muted-foreground whitespace-nowrap overflow-hidden text-ellipsis";

const providerNodeExpandIcon = "text-muted-foreground select-none text-[10px] md:text-xs w-3 shrink-0";

// LogEntryRow
const logEntryRow = "flex items-start gap-1 md:gap-1.5 py-0.5 px-1 md:py-0.5 md:px-1.5 rounded hover:bg-accent group transition-colors duration-100";

const logEntryRowMessage = "font-mono text-[10px] md:text-[11px] text-foreground leading-relaxed break-all min-w-0 truncate";

const logEntryRowTimestamp = "font-mono text-[11px] text-muted-foreground tabular-nums select-none";

// StatusBadge
const statusBadgeBase = "text-[8px] md:text-[10px] font-mono px-1 py-0.25 md:px-1.5 md:py-0.5 rounded border border-border uppercase tracking-widest";

// CircularSpinner
const spinnerSvg = "shrink-0";

const spinnerPending = "opacity-40";

const spinnerLoading = "animate-spin";

export {
  waiting,
  container,
  providerNode,
  providerNodeEntriesWrapper,
  providerNodeEntryMessage,
  providerNodeExpandIcon,
  logEntryRow,
  logEntryRowMessage,
  logEntryRowTimestamp,
  statusBadgeBase,
  spinnerSvg,
  spinnerPending,
  spinnerLoading,
};
